import { Skeleton } from '@repo/ui/components/ui/skeleton';
import { LoaderCircle } from 'lucide-react';
import { useScreenSize } from '@repo/ui/hooks';

export const StageLoading = () => {
  const { isSmall, is2XL } = useScreenSize();
  return (
    <div className="flex flex-row flex-wrap w-full gap-2">
      {Array.from({ length: isSmall ? 2 : is2XL ? 12 : 8 }).map((_, index) => (
        <section
          key={index}
          className="flex flex-col w-full xs:w-[calc(50%-8px)] md:w-[calc(25%-8px)] 2xl:w-[calc(16.67%-8px)] mb-8"
        >
          <Skeleton className="w-full h-[25.125rem]" />
          <Skeleton className="w-2/3 h-3 mt-1" />
          <Skeleton className="w-1/3 h-3 mt-1" />
          <section className="flex flex-row mt-1">
            <Skeleton className="w-1/2 h-9" />
            <Skeleton className="w-1/2 h-9 ml-2" />
          </section>
        </section>
      ))}
    </div>
  );
};

export const LOADING_MEDIA_TYPES = {
  SPINNER: 'spinner',
  SKELETON: 'skeleton',
} as const;

export const LOADING_MEDIA_POSITIONS = {
  bottom: 'bottom',
  top: 'top',
  center: 'center',
} as const;

export type LoadingMediaType =
  (typeof LOADING_MEDIA_TYPES)[keyof typeof LOADING_MEDIA_TYPES];

export type LoadingMediaPosition =
  (typeof LOADING_MEDIA_POSITIONS)[keyof typeof LOADING_MEDIA_POSITIONS];

type LoadingMediaProps =
  | {
      type: typeof LOADING_MEDIA_TYPES.SPINNER;
      position: LoadingMediaPosition;
    }
  | {
      type: typeof LOADING_MEDIA_TYPES.SKELETON;
      position?: never;
    };

export function LoadingMedia({ type, position }: LoadingMediaProps) {
  let verticalPosition;
  if (position === 'top') verticalPosition = 'items-start';
  if (position === 'bottom') verticalPosition = 'items-end';
  if (position === 'center') verticalPosition = 'items-center';

  if (type === LOADING_MEDIA_TYPES.SPINNER) {
    return (
      <div
        className={`flex absolute inset-0 ${verticalPosition} justify-center pb-6 z-10`}
      >
        <LoaderCircle className="size-8 animate-spin" />
      </div>
    );
  } else if (type === LOADING_MEDIA_TYPES.SKELETON) {
    return (
      <div className="absolute inset-0 flex justify-center items-center z-10">
        <Skeleton className="size-full bg-zinc-200 rounded-none" />
      </div>
    );
  } else return null;
}
